import { graphql } from "@/lib/gql/__generated__/gql";

export const HotelPolicyI18nEditMutation = graphql(/* GraphQL */ `
	mutation HotelPolicyI18nUpdate($hotelPolicyI18nInput: HotelPolicyI18nInput!) {
		hotelPolicyI18nUpdate(input: $hotelPolicyI18nInput) {
			userErrors
			hotelPolicyI18n {
				id
				lang
				hotelID
				hotelInfo {
					title
					description
				}
				questions {
					questionID
					required
					questionType
					question
					options
				}
				additionalFees {
					additionalID
					name
					price {
						currencyType
						amount
					}
					billingTypeTerm
					billingTypeTarget
					isNotDiscountTarget
					isNotTargetOnDayTrip
					isExcludeCancelFeeTarget
					useKidsPrice
					kidsPrices {
						kidsMaxAge
					}
					billingTypeTermValidation
					termValidationApplyStartDt
					termValidationApplyEndDt
				}
			}
		}
	}
`);
